<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>赛事项目管理</h3></div>
    <el-form
      :inline="!UI.isMobile"
      :label-position="UI.isMobile ? 'top' : 'right'"
      size="mini"
      :model="filterForm"
    >
      <el-form-item label="选择赛事">
        <el-select v-model="filterForm.game_id">
          <el-option
            v-for="(item, index) in gameOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="项目">
        <el-input
          clearable
          v-model="filterForm.title"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            flushData();
          "
        >
          查询
        </el-button>
        <el-button
          @click="
            filterForm = { page: 1, page_size: 10 };
            flushData();
          "
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div style="margin-left: 47px; margin-right: 180px">
            <el-table :data="props.row.results" border>
              <el-table-column width="100" prop="sort" label="名次" sortable>
                <template slot-scope="scope">
                  {{
                    parseFloat(scope.row.sort).toString() == 'NaN'
                      ? scope.row.sort
                      : Number(scope.row.sort)
                  }}
                </template>
              </el-table-column>
              <el-table-column
                width="120"
                prop="num"
                label="参赛号"
                sortable
              ></el-table-column>

              <el-table-column label="姓名">
                <template slot-scope="scope">
                  {{ scope.row.user_info.name }}
                </template>
              </el-table-column>
              <el-table-column label="证件号码">
                <template slot-scope="scope">
                  {{ scope.row.user_info.identifier_code }}
                </template>
              </el-table-column>
              <el-table-column
                prop="group"
                label="组别"
                sortable
              ></el-table-column>
              <el-table-column
                prop="org"
                label="单位"
                sortable
              ></el-table-column>
              <el-table-column
                prop="result"
                label="成绩"
                sortable
              ></el-table-column>
              <el-table-column
                prop="time_difference"
                label="时差"
                sortable
              ></el-table-column>
              <el-table-column
                prop="evidence_data"
                label="证书配置"
              ></el-table-column>
              <el-table-column label="预览证书" width="120">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="showEvidence(props.row, scope.row)"
                  >
                    点击预览
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="报名附件" width="120">
                <template slot-scope="scope">
                  <a
                    :href="scope.row.attach"
                    target="_blank"
                    v-if="scope.row.attach"
                  >
                    点击下载
                  </a>
                </template>
              </el-table-column>
              <el-table-column label="删除" width="120">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteResult(scope.row.id)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="赛事">
        <template slot-scope="scope">
          {{ getTitleForGame(scope.row.game_id) }}
        </template>
      </el-table-column>

      <el-table-column prop="title" label="项目"></el-table-column>
      <el-table-column prop="desc" label="描述">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="
              showContent = scope.row.desc;
              isContentShow = true;
            "
          >
            点击预览
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="已报名人数">
        <template slot-scope="scope">
          {{ scope.row.results.length }}
        </template>
      </el-table-column>
      <el-table-column label="名单管理">
        <template slot-scope="scope">
          <el-button
            @click="
              handleExportUserExcel(
                `${getTitleForGame(scope.row.game_id)}-${
                  scope.row.title
                }-${new Date().getFullYear()}-${new Date().getMonth() +
                  1}-${new Date().getDate()}`,
                scope.row.title,
                scope.row.results,
                scope.row.is_judge_game,
              )
            "
            type="primary"
            size="small"
          >
            名单导出
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="成绩管理">
        <template slot-scope="scope">
          <el-button
            @click="
              handleExportExcel(
                `${getTitleForGame(scope.row.game_id)}-${
                  scope.row.title
                }-${new Date().getFullYear()}-${new Date().getMonth() +
                  1}-${new Date().getDate()}`,
                scope.row.results,
              )
            "
            type="primary"
            size="small"
          >
            成绩导出
          </el-button>

          <el-button
            @click="handleImportExcel(scope.row.id)"
            type="primary"
            size="small"
          >
            成绩导入
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button
            @click="
              gameInfo = {};
              isShow = true;
            "
            type="primary"
            size="small"
          >
            发布赛事项目
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button
            @click="
              gameInfo = scope.row;
              defaultContent = scope.row.desc;
              isShow = true;
            "
            type="primary"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            @click="handleDeleteGame(scope.row.id)"
            type="danger"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="查看"
      :visible.sync="isContentShow"
      show-close
      :fullscreen="UI.isMobile"
    >
      <div v-html="showContent"></div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="isShowEvidence"
      show-close
      width="840px"
      v-if="isShowEvidence"
      :fullscreen="UI.isMobile"
    >
      <div style="position: relative" ref="evidence">
        <img :src="evidence.evidencePicture" width="800px" />
        <div
          v-for="(item, index) in evidence.evidenceData"
          :key="index"
          style="position: absolute;"
          :style="
            `top: ${item.top}; left: ${item.left}; font-size:${item.fontSize}; size:${item.size}`
          "
        >
          {{ item.text }}
        </div>
      </div>
      <div class="flex justify-center align-center">
        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="exportEvidence()"
        >
          导出
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="发布赛事项目"
      :visible.sync="isShow"
      fullscreen
      show-close
    >
      <div class="flex flex-direction align-center gameinfo">
        <el-form
          ref="gameInfoForm"
          :model="gameInfo"
          :rules="gameInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="所属赛事" prop="game_id">
            <el-select v-model="gameInfo.game_id">
              <el-option
                v-for="(item, index) in gameOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="项目标题" prop="title">
            <el-input
              placeholder="请输入标题"
              clearable
              v-model="gameInfo.title"
            ></el-input>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="submit()"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGamesList,
  getGameItemsList,
  addGameItem,
  deleteGameItem,
  importResult,
  deleteGameItemResult,
} from '@/servers/admin.js';
import { showSuccessMsg, showErrorMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import html2canvas from 'html2canvas';

export default {
  data() {
    return {
      gameOptions: [],
      isContentShow: false,
      showContent: '',
      defaultContent: '',
      gameInfo: {},
      isShow: false,
      isShowEvidence: false,
      evidence: {},
      filterForm: {
        page: 1,
        page_size: 5,
      },
      total: 0,
      tableData: [],
      gameInfoRules: {
        game_id: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.getGameOptions();
  },

  methods: {
    exportEvidence: function() {
      const ref = this.$refs.evidence; // 截图区域
      html2canvas(ref, {
        backgroundColor: '#ffffff',
        useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png');
        const creatDom = document.createElement('a');
        document.body.appendChild(creatDom);
        creatDom.href = dataURL;
        creatDom.download = '图片';
        creatDom.click();
      });
    },

    deleteResult: function(resultId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteGameItemResult(resultId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    handleExportUserExcel: function(name, gameItem, result, isJudgeGame) {
      const sheetData1 = result.map((item, index) => {
        const row = {
          序号: index + 1,
          项目: gameItem,
          姓名: item.user_info.name,
          性别: item.user_info.sex == 0 ? '男' : '女',
          [isJudgeGame ? '岗位' : '组别']: item.group,
          身份证号: item.user_info.identifier_code,
          电话: item.user_info.mobile,
          邮箱: item.user_info.email,
          注册号: item.user_id,
          单位名称: item.org_name,
          联系人: item.contact,
          联系人手机: item.contact_mobile,
          出生年: item.user_info.birthday
            ? item.user_info.birthday.substring(0, 4)
            : '',
          籍贯:
            item.user_info.native_place && item.user_info.native_place.length
              ? item.user_info.native_place.join()
              : '',
          民族: item.user_info.nation,
          免冠头像: item.user_info.avatar,
          报名附件: item.attach,
        };
        if (isJudgeGame) {
          row.裁判培训等级 = item.user_info.referee_level || '';
        }
        return row;
      });
      const sheet1 = XLSX.utils.json_to_sheet(sheetData1);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet1, '参赛名单');
      XLSX.writeFile(wb, `参赛名单-${name}.xlsx`);
    },

    handleExportExcel: function(name, result) {
      const sheetData1 = result.map((item) => ({
        名次: item.sort,
        参赛号: item.num,
        姓名: item.user_info.name,
        组别: item.group,
        单位: item.org,
        成绩: item.result,
        时差: item.time_difference,
        证件号码: item.user_info.identifier_code,
        证书配置: item.evidence_data,
        报名附件: item.attach,
      }));
      const sheet1 = XLSX.utils.json_to_sheet(sheetData1);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet1, '成绩列表');
      XLSX.writeFile(wb, `成绩列表-${name}.xlsx`);
    },

    handleImportExcel: function(gameItemId) {
      let that = this;
      let inputObj = document.createElement('input');
      inputObj.setAttribute('id', 'file');
      inputObj.setAttribute('type', 'file');
      inputObj.setAttribute('name', 'file');
      inputObj.setAttribute('style', 'visibility:hidden');
      inputObj.setAttribute('accept', '.xlsx');
      inputObj.addEventListener('change', (evt) => {
        const files = evt.target.files;
        if (files && files[0])
          this._file(files[0], (data, dataRef) => {
            importResult(gameItemId, data, function(res) {
              showSuccessMsg(res);
              that.flushData();
            });
          });
      });
      document.body.appendChild(inputObj);
      inputObj.value;
      inputObj.click();
    },

    _file: function(file, callback) {
      const make_cols = (refstr) =>
        Array(XLSX.utils.decode_range(refstr).e.c + 1)
          .fill(0)
          .map((x, i) => ({
            name: XLSX.utils.encode_col(i),
            key: i,
          }));

      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, {
          type: 'binary',
        });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, {
          header: 1,
        });
        /* Update state */
        callback(data, make_cols(ws['!ref']));
      };
      reader.readAsBinaryString(file);
    },

    getGameOptions: function() {
      let that = this;
      getGamesList({ page_size: 50 }, function(res) {
        that.gameOptions = [];
        res.items.forEach((item) => {
          that.gameOptions.push({
            label: item.title,
            value: item.id,
          });
        });
        that.flushData();
      });
    },

    getTitleForGame: function(game_id) {
      for (let index in this.gameOptions) {
        if (this.gameOptions[index].value == game_id) {
          return this.gameOptions[index].label;
        }
      }
      return '';
    },

    flushData: function() {
      let that = this;
      this.page = 1;
      getGameItemsList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    handleDeleteGame: function(fileId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteGameItem(fileId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function() {
      let that = this;
      this.$refs.gameInfoForm.validate((valid) => {
        if (valid) {
          addGameItem(this.gameInfo, function(res) {
            that.gameInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },

    showEvidence: function(gameRow, itemRow) {
      if (!gameRow.evidence_config || !itemRow.evidence_data) {
        showErrorMsg('未正确配置');
        return;
      }
      this.evidence = {
        evidencePicture: gameRow.evidence_picture,
        evidenceData: [],
      };
      let evidence_config = gameRow.evidence_config.split(';');
      let evidence_data = itemRow.evidence_data.split(';');

      for (let index in evidence_config) {
        let item_evidence_config = evidence_config[index].split(',');

        this.evidence.evidenceData.push({
          top: item_evidence_config[0] + 'px',
          left: item_evidence_config[1] + 'px',
          fontSize: item_evidence_config[2] + 'px',
          color: item_evidence_config[3],
          text: evidence_data[index],
        });
      }
      this.isShowEvidence = true;
    },
  },
};
</script>

<style lang="scss">
.gameinfo {
  .el-form-item__content {
    line-height: unset !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/games/gameItems.vue